import assest from "../../../json/assest";
// import Image from "next/image";
import React, { useEffect } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import EmptyTable from "../../../components/EmptyTable/EmptyTable";
import NoResult from "../../../components/NoResult/NoResult";
import styles from "../../../styles/components/BuyerPageTable/BuyerPageTable.module.scss";
import styles1 from "../../../styles/components/partnerSubmissionFeeModal.module.scss";
import styles2 from "../../../styles/pages/home.module.scss";
import styles4 from "../../../styles/components/buyerListSubmissionfeeModal.module.scss";
import BuyerPendingVideoTable from "./BuyerPendingVideoTable";
import BuyerAllPlatfromTable from "./BuyerAllPlatfromTable";
import BuyerWebsiteTable from "./BuyerWebsiteTable";
import BuyerDuplicateTable from "./BuyerDuplicateTable";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useQuery } from "react-query";
import { contentBuyerVideoList } from "../../../api/functions/contentBuyer";
import { useAppSelector } from "../../../hooks/useAppSelector";
import Filter from "../../Filter/Filter";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import {
  setDuplicates,
  setFrom,
  setHasNote,
  setTo,
  setUnreachableSubmitter,
  setMonth,
  setYear,
  updateData,
  setSubmitPlace,
  setManagerId,
  setPublished,
  updateQuery,
  setInquirerValue,
  setInquirerKey,
  setStatus,
  setConfirm,
  setManagerDecision,
  setAwaitingConfirmation,
} from "../../../redux-toolkit/slices/contentBuyer.slice";
import ApiLoader from "../../Loaders/ApiLoader";
import PendingVideoIcon from "../../../public/assets/icons/PendingVideoIcon";
import ApproveIcon from "../../../public/assets/icons/ApproveIcon";
import ApprovedVideoIcon from "../../../public/assets/icons/ApprovedVideoIcon";
import WebsiteIcon from "../../../public/assets/icons/WebsiteIcon";
import DuplicatedVideoIcon from "../../../public/assets/icons/DuplicatedVideoIcon";
import WebsiteIconTwo from "../../../public/assets/icons/WebsiteIconTwo";
import { getStartEndDateTwo } from "../../../lib/functions/utils.lib";

// interface TabPanelProps {
//     children?: React.ReactNode;
//     index: number;
//     value: number;
// }

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box className={styles.buyerCommonTable}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BuyerPageTable(props) {
  const { buyer_id, contentBuyerSubmissions } = props;
  const dispatch = useAppDispatch();
  const [openFilterModal, setOpenFilterModal] = React.useState(false);

  const [page, setPage] = React.useState(1);
  const [statusValue, setStatusValue] = React.useState(0);
  const [value, setValue] = React.useState(0);
  const [fetchTrigger, setFetchTrigger] = React.useState(Date.now());
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handlePageChange = (e) => {
    setPage(e);
    handleTriggreFetch();
  };

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  const {
    status,
    month,
    year,
    duplicate,
    has_note,
    unreachable_submitter,
    from,
    to,
    query,
    submit_place,
    manager_id,
    published,
    inquirer_key,
    inquirer_value,
    managerDecision,
    awaiting_confirmation,
  } = useAppSelector((s) => s.contentBuyerSlice);

  const filtersReset = () => {
    setPage(1);
    dispatch(setHasNote(null));
    dispatch(setFrom(null));
    dispatch(setTo(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setDuplicates(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setSubmitPlace(null));
    dispatch(setManagerId(null));
    dispatch(setPublished(null));
    dispatch(updateQuery(null));
    dispatch(setInquirerKey(null));
    dispatch(setInquirerValue(null));
    handleTriggreFetch();
  };

  const handleClearFilterModal = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setDuplicates(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setManagerId(null));
    dispatch(setPublished(null));
    dispatch(setManagerId(null));
    dispatch(setPublished(null));
    dispatch(setInquirerKey(null));
    dispatch(setInquirerValue(null));
    setOpenFilterModal(false);
    handleTriggreFetch();
  };

  const handelStatusValue = (value) => {
    dispatch(setStatus(value));
    dispatch(setConfirm(false));
    dispatch(setManagerDecision(null));
    dispatch(setAwaitingConfirmation(null));
    setPage(1);
    filtersReset();
  };
  const handleDuplicateVideos = () => {
    filtersReset();
    dispatch(setStatus(null));
    dispatch(setDuplicates("yes"));
    setPage(1);
    dispatch(setConfirm(false));
    dispatch(setManagerDecision(null));
    dispatch(setAwaitingConfirmation(null));
  };

  const {
    data: contentBuyerVideoData,
    isLoading,
    refetch,
    error,
    isRefetching,
  } = useQuery(
    ["contentBuyerVideo"],
    async () =>
      contentBuyerVideoList({
        buyer_id: buyer_id,
        status,
        page,
        search: query,
        from: month || year ? getStartEndDateTwo(month, year).start_date : from,
        to: month || year ? getStartEndDateTwo(month, year).end_date : to,
        duplicate,
        has_note,
        unreachable_submitter,
        submit_place,
        manager_id,
        published,
        awaiting_confirmation,
        manager_decision:
          inquirer_key == "manager_id"
            ? 5
            : managerDecision === 1
            ? 1
            : managerDecision === 5
            ? 5
            : null,
        quality_team_decision: inquirer_key == "quality_team_id" ? 5 : null,
      }),
    {
      onSuccess: (data) => {
        dispatch(updateData(data?.data?.data));
      },
    }
  );

  const filterRefetch = () => {
    refetch();
    setOpenFilterModal(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      refetch();
    }, 300);
    return () => clearTimeout(timer);
  }, [query]);

  useEffect(() => {
    refetch();
  }, [page, statusValue, from, to, fetchTrigger]);

  return (
    <Box className={`${styles1.submitTableMain} ${styles.bodyScroll}`}>
      <ApiLoader loading={isLoading || isRefetching} />
      {/* <PerfectScrollbar> */}
      <Box className={styles.bttmGap}>
        <Box className={styles4.submitHeader}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            className={styles.buyerTableHeader}
          >
            <Tab
              onClick={() => handelStatusValue(0)}
              label={
                <>
                  <Box className="tabBox">
                    <Box className="tabIcon">
                      {/* <img
                          src={assest.pendingIcon}
                          width={22}
                          height={22}
                          alt=""
                        /> */}
                      <PendingVideoIcon />
                    </Box>
                    <p>
                      Pending Videos <br />{" "}
                      {
                        contentBuyerSubmissions?.data?.data?.all_submissions
                          ?.pending
                      }
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(0)}
            />
            <Tab
              onClick={() => handelStatusValue(1)}
              label={
                <>
                  <Box className="tabBox">
                    <Box className="tabIcon">
                      {/* <img
                          src={assest.allPlatfromIcon}
                          width={22}
                          height={22}
                          alt=""
                        /> */}
                      <ApprovedVideoIcon color={"#000"} />
                    </Box>
                    <p>
                      All-platform <br />{" "}
                      {
                        contentBuyerSubmissions?.data?.data?.all_submissions
                          ?.approved
                      }
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(1)}
            />
            <Tab
              onClick={() => handelStatusValue(5)}
              label={
                <>
                  <Box className="tabBox">
                    <Box className="tabIcon">
                      {/* <img
                          src={assest.globalIcon}
                          width={22}
                          height={22}
                          alt=""
                        /> */}
                      <WebsiteIconTwo />
                    </Box>
                    <p>
                      Website Only <br />{" "}
                      {
                        contentBuyerSubmissions?.data?.data?.all_submissions
                          ?.website_only
                      }
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(2)}
            />
            <Tab
              // onClick={handleDuplicateVideos}
              onClick={() => handelStatusValue(6)}
              label={
                <>
                  <Box className="tabBox">
                    <Box className="tabIcon">
                      {/* <img
                          src={assest.duplicateIcon}
                          width={22}
                          height={22}
                          alt=""
                        /> */}
                      <DuplicatedVideoIcon />
                    </Box>
                    <p>
                      Duplicated Videos <br />{" "}
                      {
                        contentBuyerSubmissions?.data?.data?.all_submissions
                          ?.duplicate_videos
                      }
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>

        <Box className={`${styles1.submitTablePartner} ${styles2.submitTable}`}>
          <TabPanel value={value} index={0}>
            <BuyerPendingVideoTable
              videos={contentBuyerVideoData?.data}
              handlePageChange={handlePageChange}
              handleTriggreFetch={handleTriggreFetch}
              filtersReset={filtersReset}
              filterRefetch={filterRefetch}
              handleClearFilterModal={handleClearFilterModal}
              p={{
                openFilterModal,
                setOpenFilterModal,
              }}
            />
          </TabPanel>

          <TabPanel value={value} index={1}>
            <BuyerAllPlatfromTable
              videos={contentBuyerVideoData?.data}
              handlePageChange={handlePageChange}
              handleTriggreFetch={handleTriggreFetch}
              filtersReset={filtersReset}
              filterRefetch={filterRefetch}
              handleClearFilterModal={handleClearFilterModal}
              p={{
                openFilterModal,
                setOpenFilterModal,
              }}
            />
          </TabPanel>

          <TabPanel value={value} index={2}>
            <BuyerWebsiteTable
              videos={contentBuyerVideoData?.data}
              handlePageChange={handlePageChange}
              handleTriggreFetch={handleTriggreFetch}
              filtersReset={filtersReset}
              filterRefetch={filterRefetch}
              handleClearFilterModal={handleClearFilterModal}
              p={{
                openFilterModal,
                setOpenFilterModal,
              }}
            />
          </TabPanel>

          <TabPanel value={value} index={3}>
            <BuyerDuplicateTable
              videos={contentBuyerVideoData?.data}
              handlePageChange={handlePageChange}
              handleTriggreFetch={handleTriggreFetch}
              filtersReset={filtersReset}
              filterRefetch={filterRefetch}
              handleClearFilterModal={handleClearFilterModal}
              p={{
                openFilterModal,
                setOpenFilterModal,
              }}
            />
          </TabPanel>
        </Box>
      </Box>
      {/* </PerfectScrollbar> */}
    </Box>
  );
}
